import { LocationState, SearchState, ThingsToDoShelfState } from '../../types';
import { STORE_EVENT_SEARCH_AND_LOCATION_BY_URL } from '../actions/previousUrlContext';

export type PreviousUrlContextState = Record<
    string,
    {
        search: SearchState;
        location: LocationState;
        thingsToDoShelf: ThingsToDoShelfState;
    }
>;

export const previousUrlContextReducer = (
    state = {},
    { type, payload }: { type: string; payload?: any },
) => {
    if (type === STORE_EVENT_SEARCH_AND_LOCATION_BY_URL) {
        const { url, search, location, thingsToDoShelf } = payload;

        return {
            ...state,
            [url]: {
                search,
                location,
                thingsToDoShelf,
            },
        };
    }

    return state;
};
